import { FilterKey } from '@studyportals/search-filters';
import { RouteFragment } from '../RouteFragment';
import { RouteParams } from '../RouteParams';
import { RouteFragmentDetails } from '../RouteFragmentDetails';
import { RouteFilter } from '../RouteFilter';
import { IEmbeddedState } from '@/url/IEmbeddedState';

export class RouteAttendanceOnline extends RouteFilter {

	public static readonly fragmentType: typeof RouteAttendanceOnline = RouteAttendanceOnline;

	public constructor() {
		super(
			'Attendance',
			FilterKey.DELIVERY_METHOD,
			new RouteFragmentDetails(RouteParams.ATTENDANCE, [
				{
					value: 'online',
					path: 'online',
					pathAlternatives: [],
				},
			])
		);
	}

	public instantiate(): RouteFragment {
		return new RouteAttendanceOnline();
	}

	protected override async selfSupports(embeddedState: IEmbeddedState): Promise<boolean> {
		const selected = embeddedState.filterSelectionState.reactive.getFor(this.key);

		return Promise.resolve(selected.length === 1 && selected[0] === 'online');
	}
}
